import { render, staticRenderFns } from "./CotationDebugger.vue?vue&type=template&id=1c7de4a4&scoped=true"
import script from "./CotationDebugger.vue?vue&type=script&lang=ts"
export * from "./CotationDebugger.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7de4a4",
  null
  
)

export default component.exports